module.exports = __webpack_public_path__ + "img/headshot-placeholder.bc60caf1.svg";